import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { Confirmation } from 'src/app/enums/confirmation.enum';
import { ErrorText } from 'src/app/enums/error-text.enum';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { ApiService } from 'src/app/services/api.service';
import { ContentActionComponent } from 'src/app/shared/content-action/content-action.component';
import { FormControl, FormGroup } from '@angular/forms';
import { FilterFormModal, FilterValue } from 'src/app/models/form-group.model';
import { CommonService } from 'src/app/services/common.service';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import {SelectionModel} from '@angular/cdk/collections';


@Component({
  selector: 'fury-service-list',
  templateUrl: './service-list.component.html',
  styleUrls: ['./service-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class ServiceListComponent implements OnInit {

  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  @Input() columns = [
    { name: 'Select', property: 'select', visible: true, isModelProperty: true },
    { name: 'Title', property: 'title', visible: true, isModelProperty: true },
    { name: 'Description', property: 'description', visible: true, isModelProperty: true },
    { name: 'Status', property: 'status', visible: true, isModelProperty: true },
    { name: 'Action', property: 'actions', visible: true },
  ];
  servicelist = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  pageIndex: number = 0;
  totalCount: number = 0;
  pageSize: number = 30;
  searchedKeyword: string = '';
  searchBy: string = 'title';
  searchType: string = 'contains';
  isShowFilter: boolean = false;
  serchByValue: FilterValue[] = [
    {title: 'Title', value: 'title'},
    {title: 'Description', value: 'description'}
  ];

  filterForm = new FormGroup<FilterFormModal>({
    searchBy: new FormControl(this.searchBy),
    searchType: new FormControl(this.searchType),
  });
  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }
  selection = new SelectionModel(true, []);
  constructor(
    private api: ApiService,
    private dialog: MatDialog, 
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public commonService: CommonService
    ) {
    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;  
      this.searchBy = res.searchBy ? res.searchBy : 'title';
      this.searchType = res.searchType ? res.searchType : 'contains';
      this.filterForm.patchValue({
        searchBy: this.searchBy,
        searchType: this.searchType
      });     
    });
   }

  ngOnInit(): void {this.getServiceList()}
 
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(`/settings/service/service-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.getServiceList();
  }
  onFilterChange(value: string){
      this.pageIndex = 0;
      this.searchedKeyword = value.trim();
      this.router.navigateByUrl(`/settings/service/service-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
      this.getServiceList();
  }
  openDialog(type: string, id: string){
    const dialogref = this.dialog.open(ContentActionComponent, { width: '500px', data: { type } });
    dialogref.afterClosed().subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.api.delete(`admin/service/delete-service/${id}`).subscribe((del: any) => {
          if (del.body) {
            this.api.alert(del.body.message, ErrorType.Success);
            this.getServiceList();
          }
        }, err => {
          if (err) {
            this.api.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
          }
        });
      }
    });
  }
  getServiceList(){
    this.api.get(`admin/service/get-all-services?page=${this.pageIndex + 1}&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`)
    .subscribe({
      next: (res: HttpResponse<any>) => {
        if(res.status === 200){
          this.totalCount = res.body.services.total;
          this.dataSource = new MatTableDataSource(res.body.services.data);
          this.selection = new SelectionModel(true, []);
        }
      },
      error: (err: HttpErrorResponse) => {}
    })
  };

  showFilter(){
    this.isShowFilter = !this.isShowFilter; 
  };
  filterChange(){
    this.searchType = this.filterForm.value.searchType;
    this.searchBy = this.filterForm.value.searchBy;
    this.router.navigateByUrl(`/settings/service/service-list?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&searchBy=${this.searchBy}&searchType=${this.searchType}`);
    this.isShowFilter = false;
    this.getServiceList();
  };

  changeStatus(event: MatSlideToggleChange, row: any) {
    let data :any;
    data = {isActive: event.checked};
    this.api.patch(`admin/service/change-status/${row.serviceId}`, data).subscribe((res: any) => {
      if (res.body) {
        this.api.alert(res.body.message, ErrorType.Success);
      } else {
        row.isActive = !row.isActive;
        this.api.alert(res.body.message, ErrorType.Warning);
      }
    }, err => {
      if (err) {
        row.isActive = !row.isActive;
        Object.keys(err.errors).map((error) => {
          this.api.alert(err.errors[error], ErrorType.Error);
        })
      }
    });
  };


   isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  };

  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  };

  deleteMultipleServices(){
    if(this.selection.selected.length < 1){
      this.api.alert('Please select minimum one Service!', ErrorType.Error);
      return;
    };
    const type :string = 'delete';
    let serviceId = this.selection.selected.map((item: any) => item.serviceId);
    const dialogref = this.dialog.open(ContentActionComponent, { width: '500px', data: { type } });
    dialogref.afterClosed().subscribe((res: Confirmation) => {
      if (res === Confirmation.Yes) {
        this.api.deleteMulti(`admin/service/delete-services`, {serviceId}).subscribe((del: any) => {
          if (del) {
            this.api.alert(del.message, ErrorType.Success);
            this.getServiceList();
          }
        }, err => {
          if (err) {
            this.api.alert(ErrorText.SomeThingWentWrong, ErrorType.Error);
          }
        });
      }
    });
  };
}
